(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js', './kotlinx-serialization-kotlinx-serialization-core-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-core-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'reporting-shared'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'reporting-shared'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'reporting-shared'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-ir' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-ir' is loaded prior to 'reporting-shared'.");
    }
    root['reporting-shared'] = factory(typeof this['reporting-shared'] === 'undefined' ? {} : this['reporting-shared'], this['kotlin-kotlin-stdlib-js-ir'], this['kotlinx-serialization-kotlinx-serialization-core-js-ir']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var Unit_getInstance = kotlin_kotlin.$_$.j;
  var createAnnotatedEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.b;
  var lazy = kotlin_kotlin.$_$.t1;
  var protoOf = kotlin_kotlin.$_$.l1;
  var objectMeta = kotlin_kotlin.$_$.k1;
  var VOID = kotlin_kotlin.$_$.w1;
  var setMetadataFor = kotlin_kotlin.$_$.m1;
  var Enum = kotlin_kotlin.$_$.r1;
  var classMeta = kotlin_kotlin.$_$.a1;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.c;
  var copyToArray = kotlin_kotlin.$_$.n;
  var interfaceMeta = kotlin_kotlin.$_$.h1;
  var KProperty1 = kotlin_kotlin.$_$.p1;
  var getPropertyCallableRef = kotlin_kotlin.$_$.e1;
  var defineProp = kotlin_kotlin.$_$.b1;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(Type, 'Type', classMeta, Enum, VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(EventType, 'EventType', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_0});
  setMetadataFor(FilterOperation, 'FilterOperation', classMeta, Enum);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(State, 'State', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_1});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(Taxonomy, 'Taxonomy', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_2});
  setMetadataFor(Confidence, 'Confidence', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_3});
  setMetadataFor(Status, 'Status', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_4});
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(YesNoUnknown, 'YesNoUnknown', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_5});
  setMetadataFor(EmailStatus, 'EmailStatus', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_6});
  setMetadataFor(Notified, 'Notified', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_7});
  setMetadataFor(Direction, 'Direction', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_8});
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(SenderPolicyType, 'SenderPolicyType', classMeta, Enum, VOID, VOID, {0: Companion_getInstance_9});
  setMetadataFor(Field, 'Field', classMeta);
  setMetadataFor(FieldType, 'FieldType', objectMeta);
  function names(_this__u8e3s4) {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(_this__u8e3s4.length);
    var indexedObject = _this__u8e3s4;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'Fields.names.<anonymous>' call
      tmp$ret$0 = item.b7_1 === 'MISSING' ? null : item.b7_1;
      tmp0_mapTo.f(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_toTypedArray = tmp$ret$2;
    tmp$ret$3 = copyToArray(tmp1_toTypedArray);
    return tmp$ret$3;
  }
  setMetadataFor(Fields, 'Fields', interfaceMeta);
  setMetadataFor(AutomatedWorkflowsEventFields, 'AutomatedWorkflowsEventFields', objectMeta, VOID, [Fields]);
  setMetadataFor(InsightsUserSubmissionFields, 'InsightsUserSubmissionFields', objectMeta, VOID, [Fields]);
  setMetadataFor(RemediationEmailFields, 'RemediationEmailFields', objectMeta, VOID, [Fields]);
  setMetadataFor(RemediationIncidentFields, 'RemediationIncidentFields', objectMeta, VOID, [Fields]);
  setMetadataFor(PipelineSpThreatFields, 'PipelineSpThreatFields', objectMeta, VOID, [Fields]);
  setMetadataFor(FilterOperation_0, 'FilterOperation', objectMeta);
  //endregion
  function AutomatedWorkflowsEvent$Node$Type$Companion$_anonymous__f6ao2n() {
    var tmp = values();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Trigger', 'Condition', 'Action'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.AutomatedWorkflowsEvent.Node.Type', tmp, tmp_0, tmp$ret$5, null);
  }
  var Type_TRIGGER_instance;
  var Type_CONDITION_instance;
  var Type_ACTION_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ka_1 = lazy(tmp_0, AutomatedWorkflowsEvent$Node$Type$Companion$_anonymous__f6ao2n);
  }
  var Companion_instance;
  function Companion_getInstance() {
    Type_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [Type_TRIGGER_getInstance(), Type_CONDITION_getInstance(), Type_ACTION_getInstance()];
  }
  var Type_entriesInitialized;
  function Type_initEntries() {
    if (Type_entriesInitialized)
      return Unit_getInstance();
    Type_entriesInitialized = true;
    Type_TRIGGER_instance = new Type('TRIGGER', 0, 'Trigger');
    Type_CONDITION_instance = new Type('CONDITION', 1, 'Condition');
    Type_ACTION_instance = new Type('ACTION', 2, 'Action');
    Companion_getInstance();
  }
  function AutomatedWorkflowsEvent$Node$EventType$Companion$_anonymous__uneykv() {
    var tmp = values_0();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Potential incident detected', 'Sender policy created in Email Gateway', 'User-reported email submitted', 'Number of emails detected for potential incident', 'Potential incident is external', 'Potential incident is internal', 'Post-delivery threat', 'Related threat', 'Number of mailboxes affected by potential incident', 'Sender country of potential incident', 'Sender email of potential incident', 'Email subject of potential incident', 'Block sender policy', 'Quarantine sender policy', 'Policy created by', 'Number of emails detected for sender policy', 'Number of mailboxes affected by sender policy', 'Sender country of sender policy', 'User-reported email is external', 'User-reported email is internal', 'Number of mailboxes affected by user-reported email', 'Reported by', 'Number of users reported', 'Sender country of user-reported email', 'Sender email of user-reported email', 'Email subject of user-reported email', 'Create incident', 'Email notification', 'Slack notification', 'Microsoft Teams notification'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.AutomatedWorkflowsEvent.Node.EventType', tmp, tmp_0, tmp$ret$5, null);
  }
  var EventType_potentialIncident_instance;
  var EventType_senderPolicy_instance;
  var EventType_userReported_instance;
  var EventType_potentialIncidentEmailsDetectedCount_instance;
  var EventType_potentialIncidentIsExternal_noInput_instance;
  var EventType_potentialIncidentIsInternal_noInput_instance;
  var EventType_potentialIncidentIsTypePostDelivery_noInput_instance;
  var EventType_potentialIncidentIsTypeRelated_noInput_instance;
  var EventType_potentialIncidentMailboxesAffectedCount_instance;
  var EventType_potentialIncidentSenderCountry_instance;
  var EventType_potentialIncidentSenderEmail_instance;
  var EventType_potentialIncidentSubject_instance;
  var EventType_senderPolicyBlock_noInput_instance;
  var EventType_senderPolicyQuarantine_noInput_instance;
  var EventType_senderPolicyBy_instance;
  var EventType_senderPolicyEmailsDetectedCount_instance;
  var EventType_senderPolicyMailboxesAffectedCount_instance;
  var EventType_senderPolicySenderCountry_instance;
  var EventType_userReportedIsExternal_noInput_instance;
  var EventType_userReportedIsInternal_noInput_instance;
  var EventType_userReportedMatchedEmailCount_instance;
  var EventType_userReportedBy_instance;
  var EventType_userReportedReportedEmailCount_instance;
  var EventType_userReportedSenderCountry_instance;
  var EventType_userReportedSenderEmail_instance;
  var EventType_userReportedSubject_instance;
  var EventType_createIncident_instance;
  var EventType_emailNotification_instance;
  var EventType_slackNotification_instance;
  var EventType_msteamsNotification_instance;
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.la_1 = lazy(tmp_0, AutomatedWorkflowsEvent$Node$EventType$Companion$_anonymous__uneykv);
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    EventType_initEntries();
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function values_0() {
    return [EventType_potentialIncident_getInstance(), EventType_senderPolicy_getInstance(), EventType_userReported_getInstance(), EventType_potentialIncidentEmailsDetectedCount_getInstance(), EventType_potentialIncidentIsExternal_noInput_getInstance(), EventType_potentialIncidentIsInternal_noInput_getInstance(), EventType_potentialIncidentIsTypePostDelivery_noInput_getInstance(), EventType_potentialIncidentIsTypeRelated_noInput_getInstance(), EventType_potentialIncidentMailboxesAffectedCount_getInstance(), EventType_potentialIncidentSenderCountry_getInstance(), EventType_potentialIncidentSenderEmail_getInstance(), EventType_potentialIncidentSubject_getInstance(), EventType_senderPolicyBlock_noInput_getInstance(), EventType_senderPolicyQuarantine_noInput_getInstance(), EventType_senderPolicyBy_getInstance(), EventType_senderPolicyEmailsDetectedCount_getInstance(), EventType_senderPolicyMailboxesAffectedCount_getInstance(), EventType_senderPolicySenderCountry_getInstance(), EventType_userReportedIsExternal_noInput_getInstance(), EventType_userReportedIsInternal_noInput_getInstance(), EventType_userReportedMatchedEmailCount_getInstance(), EventType_userReportedBy_getInstance(), EventType_userReportedReportedEmailCount_getInstance(), EventType_userReportedSenderCountry_getInstance(), EventType_userReportedSenderEmail_getInstance(), EventType_userReportedSubject_getInstance(), EventType_createIncident_getInstance(), EventType_emailNotification_getInstance(), EventType_slackNotification_getInstance(), EventType_msteamsNotification_getInstance()];
  }
  var EventType_entriesInitialized;
  function EventType_initEntries() {
    if (EventType_entriesInitialized)
      return Unit_getInstance();
    EventType_entriesInitialized = true;
    EventType_potentialIncident_instance = new EventType('potentialIncident', 0, 'Potential incident detected');
    EventType_senderPolicy_instance = new EventType('senderPolicy', 1, 'Sender policy created in Email Gateway');
    EventType_userReported_instance = new EventType('userReported', 2, 'User-reported email submitted');
    EventType_potentialIncidentEmailsDetectedCount_instance = new EventType('potentialIncidentEmailsDetectedCount', 3, 'Number of emails detected for potential incident');
    EventType_potentialIncidentIsExternal_noInput_instance = new EventType('potentialIncidentIsExternal_noInput', 4, 'Potential incident is external');
    EventType_potentialIncidentIsInternal_noInput_instance = new EventType('potentialIncidentIsInternal_noInput', 5, 'Potential incident is internal');
    EventType_potentialIncidentIsTypePostDelivery_noInput_instance = new EventType('potentialIncidentIsTypePostDelivery_noInput', 6, 'Post-delivery threat');
    EventType_potentialIncidentIsTypeRelated_noInput_instance = new EventType('potentialIncidentIsTypeRelated_noInput', 7, 'Related threat');
    EventType_potentialIncidentMailboxesAffectedCount_instance = new EventType('potentialIncidentMailboxesAffectedCount', 8, 'Number of mailboxes affected by potential incident');
    EventType_potentialIncidentSenderCountry_instance = new EventType('potentialIncidentSenderCountry', 9, 'Sender country of potential incident');
    EventType_potentialIncidentSenderEmail_instance = new EventType('potentialIncidentSenderEmail', 10, 'Sender email of potential incident');
    EventType_potentialIncidentSubject_instance = new EventType('potentialIncidentSubject', 11, 'Email subject of potential incident');
    EventType_senderPolicyBlock_noInput_instance = new EventType('senderPolicyBlock_noInput', 12, 'Block sender policy');
    EventType_senderPolicyQuarantine_noInput_instance = new EventType('senderPolicyQuarantine_noInput', 13, 'Quarantine sender policy');
    EventType_senderPolicyBy_instance = new EventType('senderPolicyBy', 14, 'Policy created by');
    EventType_senderPolicyEmailsDetectedCount_instance = new EventType('senderPolicyEmailsDetectedCount', 15, 'Number of emails detected for sender policy');
    EventType_senderPolicyMailboxesAffectedCount_instance = new EventType('senderPolicyMailboxesAffectedCount', 16, 'Number of mailboxes affected by sender policy');
    EventType_senderPolicySenderCountry_instance = new EventType('senderPolicySenderCountry', 17, 'Sender country of sender policy');
    EventType_userReportedIsExternal_noInput_instance = new EventType('userReportedIsExternal_noInput', 18, 'User-reported email is external');
    EventType_userReportedIsInternal_noInput_instance = new EventType('userReportedIsInternal_noInput', 19, 'User-reported email is internal');
    EventType_userReportedMatchedEmailCount_instance = new EventType('userReportedMatchedEmailCount', 20, 'Number of mailboxes affected by user-reported email');
    EventType_userReportedBy_instance = new EventType('userReportedBy', 21, 'Reported by');
    EventType_userReportedReportedEmailCount_instance = new EventType('userReportedReportedEmailCount', 22, 'Number of users reported');
    EventType_userReportedSenderCountry_instance = new EventType('userReportedSenderCountry', 23, 'Sender country of user-reported email');
    EventType_userReportedSenderEmail_instance = new EventType('userReportedSenderEmail', 24, 'Sender email of user-reported email');
    EventType_userReportedSubject_instance = new EventType('userReportedSubject', 25, 'Email subject of user-reported email');
    EventType_createIncident_instance = new EventType('createIncident', 26, 'Create incident');
    EventType_emailNotification_instance = new EventType('emailNotification', 27, 'Email notification');
    EventType_slackNotification_instance = new EventType('slackNotification', 28, 'Slack notification');
    EventType_msteamsNotification_instance = new EventType('msteamsNotification', 29, 'Microsoft Teams notification');
    Companion_getInstance_0();
  }
  function Type(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.oa_1 = humanReadable;
  }
  function EventType(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.ra_1 = humanReadable;
  }
  function Type_TRIGGER_getInstance() {
    Type_initEntries();
    return Type_TRIGGER_instance;
  }
  function Type_CONDITION_getInstance() {
    Type_initEntries();
    return Type_CONDITION_instance;
  }
  function Type_ACTION_getInstance() {
    Type_initEntries();
    return Type_ACTION_instance;
  }
  function EventType_potentialIncident_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncident_instance;
  }
  function EventType_senderPolicy_getInstance() {
    EventType_initEntries();
    return EventType_senderPolicy_instance;
  }
  function EventType_userReported_getInstance() {
    EventType_initEntries();
    return EventType_userReported_instance;
  }
  function EventType_potentialIncidentEmailsDetectedCount_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentEmailsDetectedCount_instance;
  }
  function EventType_potentialIncidentIsExternal_noInput_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentIsExternal_noInput_instance;
  }
  function EventType_potentialIncidentIsInternal_noInput_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentIsInternal_noInput_instance;
  }
  function EventType_potentialIncidentIsTypePostDelivery_noInput_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentIsTypePostDelivery_noInput_instance;
  }
  function EventType_potentialIncidentIsTypeRelated_noInput_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentIsTypeRelated_noInput_instance;
  }
  function EventType_potentialIncidentMailboxesAffectedCount_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentMailboxesAffectedCount_instance;
  }
  function EventType_potentialIncidentSenderCountry_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentSenderCountry_instance;
  }
  function EventType_potentialIncidentSenderEmail_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentSenderEmail_instance;
  }
  function EventType_potentialIncidentSubject_getInstance() {
    EventType_initEntries();
    return EventType_potentialIncidentSubject_instance;
  }
  function EventType_senderPolicyBlock_noInput_getInstance() {
    EventType_initEntries();
    return EventType_senderPolicyBlock_noInput_instance;
  }
  function EventType_senderPolicyQuarantine_noInput_getInstance() {
    EventType_initEntries();
    return EventType_senderPolicyQuarantine_noInput_instance;
  }
  function EventType_senderPolicyBy_getInstance() {
    EventType_initEntries();
    return EventType_senderPolicyBy_instance;
  }
  function EventType_senderPolicyEmailsDetectedCount_getInstance() {
    EventType_initEntries();
    return EventType_senderPolicyEmailsDetectedCount_instance;
  }
  function EventType_senderPolicyMailboxesAffectedCount_getInstance() {
    EventType_initEntries();
    return EventType_senderPolicyMailboxesAffectedCount_instance;
  }
  function EventType_senderPolicySenderCountry_getInstance() {
    EventType_initEntries();
    return EventType_senderPolicySenderCountry_instance;
  }
  function EventType_userReportedIsExternal_noInput_getInstance() {
    EventType_initEntries();
    return EventType_userReportedIsExternal_noInput_instance;
  }
  function EventType_userReportedIsInternal_noInput_getInstance() {
    EventType_initEntries();
    return EventType_userReportedIsInternal_noInput_instance;
  }
  function EventType_userReportedMatchedEmailCount_getInstance() {
    EventType_initEntries();
    return EventType_userReportedMatchedEmailCount_instance;
  }
  function EventType_userReportedBy_getInstance() {
    EventType_initEntries();
    return EventType_userReportedBy_instance;
  }
  function EventType_userReportedReportedEmailCount_getInstance() {
    EventType_initEntries();
    return EventType_userReportedReportedEmailCount_instance;
  }
  function EventType_userReportedSenderCountry_getInstance() {
    EventType_initEntries();
    return EventType_userReportedSenderCountry_instance;
  }
  function EventType_userReportedSenderEmail_getInstance() {
    EventType_initEntries();
    return EventType_userReportedSenderEmail_instance;
  }
  function EventType_userReportedSubject_getInstance() {
    EventType_initEntries();
    return EventType_userReportedSubject_instance;
  }
  function EventType_createIncident_getInstance() {
    EventType_initEntries();
    return EventType_createIncident_instance;
  }
  function EventType_emailNotification_getInstance() {
    EventType_initEntries();
    return EventType_emailNotification_instance;
  }
  function EventType_slackNotification_getInstance() {
    EventType_initEntries();
    return EventType_slackNotification_instance;
  }
  function EventType_msteamsNotification_getInstance() {
    EventType_initEntries();
    return EventType_msteamsNotification_instance;
  }
  var FilterOperation_EQUALS_instance;
  var FilterOperation_NOT_EQUALS_instance;
  var FilterOperation_IN_instance;
  var FilterOperation_NOT_IN_instance;
  var FilterOperation_CONTAINS_instance;
  var FilterOperation_NOT_CONTAINS_instance;
  var FilterOperation_LESS_instance;
  var FilterOperation_LESS_EQUAL_instance;
  var FilterOperation_GREATER_instance;
  var FilterOperation_GREATER_EQUAL_instance;
  var FilterOperation_BETWEEN_instance;
  var FilterOperation_BLANK_instance;
  var FilterOperation_NOT_BLANK_instance;
  var FilterOperation_DATE_EQUALS_instance;
  var FilterOperation_entriesInitialized;
  function FilterOperation_initEntries() {
    if (FilterOperation_entriesInitialized)
      return Unit_getInstance();
    FilterOperation_entriesInitialized = true;
    FilterOperation_EQUALS_instance = new FilterOperation('EQUALS', 0);
    FilterOperation_NOT_EQUALS_instance = new FilterOperation('NOT_EQUALS', 1);
    FilterOperation_IN_instance = new FilterOperation('IN', 2);
    FilterOperation_NOT_IN_instance = new FilterOperation('NOT_IN', 3);
    FilterOperation_CONTAINS_instance = new FilterOperation('CONTAINS', 4);
    FilterOperation_NOT_CONTAINS_instance = new FilterOperation('NOT_CONTAINS', 5);
    FilterOperation_LESS_instance = new FilterOperation('LESS', 6);
    FilterOperation_LESS_EQUAL_instance = new FilterOperation('LESS_EQUAL', 7);
    FilterOperation_GREATER_instance = new FilterOperation('GREATER', 8);
    FilterOperation_GREATER_EQUAL_instance = new FilterOperation('GREATER_EQUAL', 9);
    FilterOperation_BETWEEN_instance = new FilterOperation('BETWEEN', 10);
    FilterOperation_BLANK_instance = new FilterOperation('BLANK', 11);
    FilterOperation_NOT_BLANK_instance = new FilterOperation('NOT_BLANK', 12);
    FilterOperation_DATE_EQUALS_instance = new FilterOperation('DATE_EQUALS', 13);
  }
  function FilterOperation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FilterOperation_EQUALS_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_EQUALS_instance;
  }
  function FilterOperation_NOT_EQUALS_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_NOT_EQUALS_instance;
  }
  function FilterOperation_IN_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_IN_instance;
  }
  function FilterOperation_NOT_IN_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_NOT_IN_instance;
  }
  function FilterOperation_CONTAINS_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_CONTAINS_instance;
  }
  function FilterOperation_NOT_CONTAINS_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_NOT_CONTAINS_instance;
  }
  function FilterOperation_LESS_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_LESS_instance;
  }
  function FilterOperation_LESS_EQUAL_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_LESS_EQUAL_instance;
  }
  function FilterOperation_GREATER_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_GREATER_instance;
  }
  function FilterOperation_GREATER_EQUAL_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_GREATER_EQUAL_instance;
  }
  function FilterOperation_BETWEEN_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_BETWEEN_instance;
  }
  function FilterOperation_BLANK_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_BLANK_instance;
  }
  function FilterOperation_NOT_BLANK_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_NOT_BLANK_instance;
  }
  function FilterOperation_DATE_EQUALS_getInstance() {
    FilterOperation_initEntries();
    return FilterOperation_DATE_EQUALS_instance;
  }
  function InsightsUserSubmission$State$Companion$_anonymous__muhf4() {
    var tmp = values_1();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Submitted', 'Remediated', 'Dismissed'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.InsightsUserSubmission.State', tmp, tmp_0, tmp$ret$5, null);
  }
  var State_SUBMITTED_instance;
  var State_REMEDIATED_instance;
  var State_DISMISSED_instance;
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.sa_1 = lazy(tmp_0, InsightsUserSubmission$State$Companion$_anonymous__muhf4);
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    State_initEntries();
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function values_1() {
    return [State_SUBMITTED_getInstance(), State_REMEDIATED_getInstance(), State_DISMISSED_getInstance()];
  }
  var State_entriesInitialized;
  function State_initEntries() {
    if (State_entriesInitialized)
      return Unit_getInstance();
    State_entriesInitialized = true;
    State_SUBMITTED_instance = new State('SUBMITTED', 0, 'Submitted');
    State_REMEDIATED_instance = new State('REMEDIATED', 1, 'Remediated');
    State_DISMISSED_instance = new State('DISMISSED', 2, 'Dismissed');
    Companion_getInstance_1();
  }
  function State(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.va_1 = humanReadable;
  }
  function State_SUBMITTED_getInstance() {
    State_initEntries();
    return State_SUBMITTED_instance;
  }
  function State_REMEDIATED_getInstance() {
    State_initEntries();
    return State_REMEDIATED_instance;
  }
  function State_DISMISSED_getInstance() {
    State_initEntries();
    return State_DISMISSED_instance;
  }
  function PipelineSpThreat$Taxonomy$Companion$_anonymous__xgl7pp() {
    var tmp = values_2();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Scamming', 'Impersonation', 'Conversation hijacking', 'Extortion', 'Phishing'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.PipelineSpThreat.Taxonomy', tmp, tmp_0, tmp$ret$5, null);
  }
  var Taxonomy_spam_instance;
  var Taxonomy_becSpoofing_instance;
  var Taxonomy_conversationHijacking_instance;
  var Taxonomy_blackmail_instance;
  var Taxonomy_phishing_instance;
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.wa_1 = lazy(tmp_0, PipelineSpThreat$Taxonomy$Companion$_anonymous__xgl7pp);
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    Taxonomy_initEntries();
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function values_2() {
    return [Taxonomy_spam_getInstance(), Taxonomy_becSpoofing_getInstance(), Taxonomy_conversationHijacking_getInstance(), Taxonomy_blackmail_getInstance(), Taxonomy_phishing_getInstance()];
  }
  var Taxonomy_entriesInitialized;
  function Taxonomy_initEntries() {
    if (Taxonomy_entriesInitialized)
      return Unit_getInstance();
    Taxonomy_entriesInitialized = true;
    Taxonomy_spam_instance = new Taxonomy('spam', 0, 'Scamming');
    Taxonomy_becSpoofing_instance = new Taxonomy('becSpoofing', 1, 'Impersonation');
    Taxonomy_conversationHijacking_instance = new Taxonomy('conversationHijacking', 2, 'Conversation hijacking');
    Taxonomy_blackmail_instance = new Taxonomy('blackmail', 3, 'Extortion');
    Taxonomy_phishing_instance = new Taxonomy('phishing', 4, 'Phishing');
    Companion_getInstance_2();
  }
  function PipelineSpThreat$Confidence$Companion$_anonymous__qr1bzu() {
    var tmp = values_3();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Moderate', 'High', 'Very high'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.PipelineSpThreat.Confidence', tmp, tmp_0, tmp$ret$5, null);
  }
  var Confidence_moderate_instance;
  var Confidence_high_instance;
  var Confidence_veryHigh_instance;
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.xa_1 = lazy(tmp_0, PipelineSpThreat$Confidence$Companion$_anonymous__qr1bzu);
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    Confidence_initEntries();
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function values_3() {
    return [Confidence_moderate_getInstance(), Confidence_high_getInstance(), Confidence_veryHigh_getInstance()];
  }
  var Confidence_entriesInitialized;
  function Confidence_initEntries() {
    if (Confidence_entriesInitialized)
      return Unit_getInstance();
    Confidence_entriesInitialized = true;
    Confidence_moderate_instance = new Confidence('moderate', 0, 'Moderate');
    Confidence_high_instance = new Confidence('high', 1, 'High');
    Confidence_veryHigh_instance = new Confidence('veryHigh', 2, 'Very high');
    Companion_getInstance_3();
  }
  function PipelineSpThreat$Status$Companion$_anonymous__6c2djm() {
    var tmp = values_4();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Marked as false positive', 'Message deleted', 'Moved to junk folder', 'Recipient alerted', 'System admin alerted', 'Impersonated sender alerted', 'Unknown', 'No actions taken'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null, null, null, null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.PipelineSpThreat.Status', tmp, tmp_0, tmp$ret$5, null);
  }
  var Status_markedAsFp_instance;
  var Status_deleted_instance;
  var Status_quarantined_instance;
  var Status_notifiedRecipient_instance;
  var Status_notifiedAdmin_instance;
  var Status_notifiedSender_instance;
  var Status_Oops_instance;
  var Status_MISSING_instance;
  function Companion_4() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ya_1 = lazy(tmp_0, PipelineSpThreat$Status$Companion$_anonymous__6c2djm);
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    Status_initEntries();
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function values_4() {
    return [Status_markedAsFp_getInstance(), Status_deleted_getInstance(), Status_quarantined_getInstance(), Status_notifiedRecipient_getInstance(), Status_notifiedAdmin_getInstance(), Status_notifiedSender_getInstance(), Status_Oops_getInstance(), Status_MISSING_getInstance()];
  }
  var Status_entriesInitialized;
  function Status_initEntries() {
    if (Status_entriesInitialized)
      return Unit_getInstance();
    Status_entriesInitialized = true;
    Status_markedAsFp_instance = new Status('markedAsFp', 0, 'Marked as false positive');
    Status_deleted_instance = new Status('deleted', 1, 'Message deleted');
    Status_quarantined_instance = new Status('quarantined', 2, 'Moved to junk folder');
    Status_notifiedRecipient_instance = new Status('notifiedRecipient', 3, 'Recipient alerted');
    Status_notifiedAdmin_instance = new Status('notifiedAdmin', 4, 'System admin alerted');
    Status_notifiedSender_instance = new Status('notifiedSender', 5, 'Impersonated sender alerted');
    Status_Oops_instance = new Status('Oops', 6, 'Unknown');
    Status_MISSING_instance = new Status('MISSING', 7, 'No actions taken');
    Companion_getInstance_4();
  }
  function Taxonomy(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.bb_1 = humanReadable;
  }
  function Confidence(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.eb_1 = humanReadable;
  }
  function Status(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.hb_1 = humanReadable;
  }
  function Taxonomy_spam_getInstance() {
    Taxonomy_initEntries();
    return Taxonomy_spam_instance;
  }
  function Taxonomy_becSpoofing_getInstance() {
    Taxonomy_initEntries();
    return Taxonomy_becSpoofing_instance;
  }
  function Taxonomy_conversationHijacking_getInstance() {
    Taxonomy_initEntries();
    return Taxonomy_conversationHijacking_instance;
  }
  function Taxonomy_blackmail_getInstance() {
    Taxonomy_initEntries();
    return Taxonomy_blackmail_instance;
  }
  function Taxonomy_phishing_getInstance() {
    Taxonomy_initEntries();
    return Taxonomy_phishing_instance;
  }
  function Confidence_moderate_getInstance() {
    Confidence_initEntries();
    return Confidence_moderate_instance;
  }
  function Confidence_high_getInstance() {
    Confidence_initEntries();
    return Confidence_high_instance;
  }
  function Confidence_veryHigh_getInstance() {
    Confidence_initEntries();
    return Confidence_veryHigh_instance;
  }
  function Status_markedAsFp_getInstance() {
    Status_initEntries();
    return Status_markedAsFp_instance;
  }
  function Status_deleted_getInstance() {
    Status_initEntries();
    return Status_deleted_instance;
  }
  function Status_quarantined_getInstance() {
    Status_initEntries();
    return Status_quarantined_instance;
  }
  function Status_notifiedRecipient_getInstance() {
    Status_initEntries();
    return Status_notifiedRecipient_instance;
  }
  function Status_notifiedAdmin_getInstance() {
    Status_initEntries();
    return Status_notifiedAdmin_instance;
  }
  function Status_notifiedSender_getInstance() {
    Status_initEntries();
    return Status_notifiedSender_instance;
  }
  function Status_Oops_getInstance() {
    Status_initEntries();
    return Status_Oops_instance;
  }
  function Status_MISSING_getInstance() {
    Status_initEntries();
    return Status_MISSING_instance;
  }
  function RemediationEmail$YesNoUnknown$Companion$_anonymous__y7e9mo() {
    var tmp = values_5();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Yes', 'No', 'Unknown'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.RemediationEmail.YesNoUnknown', tmp, tmp_0, tmp$ret$5, null);
  }
  var YesNoUnknown_Y_instance;
  var YesNoUnknown_N_instance;
  var YesNoUnknown_U_instance;
  function Companion_5() {
    Companion_instance_5 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ib_1 = lazy(tmp_0, RemediationEmail$YesNoUnknown$Companion$_anonymous__y7e9mo);
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    YesNoUnknown_initEntries();
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function values_5() {
    return [YesNoUnknown_Y_getInstance(), YesNoUnknown_N_getInstance(), YesNoUnknown_U_getInstance()];
  }
  var YesNoUnknown_entriesInitialized;
  function YesNoUnknown_initEntries() {
    if (YesNoUnknown_entriesInitialized)
      return Unit_getInstance();
    YesNoUnknown_entriesInitialized = true;
    YesNoUnknown_Y_instance = new YesNoUnknown('Y', 0, 'Yes');
    YesNoUnknown_N_instance = new YesNoUnknown('N', 1, 'No');
    YesNoUnknown_U_instance = new YesNoUnknown('U', 2, 'Unknown');
    Companion_getInstance_5();
  }
  function RemediationEmail$EmailStatus$Companion$_anonymous__xi0dxu() {
    var tmp = values_6();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Found', 'In Progress', 'Quarantined', 'Deleted', 'Not Found', 'Quarantine Error'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null, null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.RemediationEmail.EmailStatus', tmp, tmp_0, tmp$ret$5, null);
  }
  var EmailStatus_FO_instance;
  var EmailStatus_IP_instance;
  var EmailStatus_QU_instance;
  var EmailStatus_DE_instance;
  var EmailStatus_NF_instance;
  var EmailStatus_ER_instance;
  function Companion_6() {
    Companion_instance_6 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.jb_1 = lazy(tmp_0, RemediationEmail$EmailStatus$Companion$_anonymous__xi0dxu);
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    EmailStatus_initEntries();
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function values_6() {
    return [EmailStatus_FO_getInstance(), EmailStatus_IP_getInstance(), EmailStatus_QU_getInstance(), EmailStatus_DE_getInstance(), EmailStatus_NF_getInstance(), EmailStatus_ER_getInstance()];
  }
  var EmailStatus_entriesInitialized;
  function EmailStatus_initEntries() {
    if (EmailStatus_entriesInitialized)
      return Unit_getInstance();
    EmailStatus_entriesInitialized = true;
    EmailStatus_FO_instance = new EmailStatus('FO', 0, 'Found');
    EmailStatus_IP_instance = new EmailStatus('IP', 1, 'In Progress');
    EmailStatus_QU_instance = new EmailStatus('QU', 2, 'Quarantined');
    EmailStatus_DE_instance = new EmailStatus('DE', 3, 'Deleted');
    EmailStatus_NF_instance = new EmailStatus('NF', 4, 'Not Found');
    EmailStatus_ER_instance = new EmailStatus('ER', 5, 'Quarantine Error');
    Companion_getInstance_6();
  }
  function RemediationEmail$Notified$Companion$_anonymous__eqy37a() {
    var tmp = values_7();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Notified', 'Notification Error', 'Not Notified'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.RemediationEmail.Notified', tmp, tmp_0, tmp$ret$5, null);
  }
  var Notified_NO_instance;
  var Notified_ER_instance;
  var Notified_MISSING_instance;
  function Companion_7() {
    Companion_instance_7 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.kb_1 = lazy(tmp_0, RemediationEmail$Notified$Companion$_anonymous__eqy37a);
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    Notified_initEntries();
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function values_7() {
    return [Notified_NO_getInstance(), Notified_ER_getInstance(), Notified_MISSING_getInstance()];
  }
  var Notified_entriesInitialized;
  function Notified_initEntries() {
    if (Notified_entriesInitialized)
      return Unit_getInstance();
    Notified_entriesInitialized = true;
    Notified_NO_instance = new Notified('NO', 0, 'Notified');
    Notified_ER_instance = new Notified('ER', 1, 'Notification Error');
    Notified_MISSING_instance = new Notified('MISSING', 2, 'Not Notified');
    Companion_getInstance_7();
  }
  function RemediationEmail$Direction$Companion$_anonymous__i08vbx() {
    var tmp = values_8();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Incoming', 'Outgoing', 'Unknown'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.RemediationEmail.Direction', tmp, tmp_0, tmp$ret$5, null);
  }
  var Direction_I_instance;
  var Direction_O_instance;
  var Direction_U_instance;
  function Companion_8() {
    Companion_instance_8 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.lb_1 = lazy(tmp_0, RemediationEmail$Direction$Companion$_anonymous__i08vbx);
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    Direction_initEntries();
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function values_8() {
    return [Direction_I_getInstance(), Direction_O_getInstance(), Direction_U_getInstance()];
  }
  var Direction_entriesInitialized;
  function Direction_initEntries() {
    if (Direction_entriesInitialized)
      return Unit_getInstance();
    Direction_entriesInitialized = true;
    Direction_I_instance = new Direction('I', 0, 'Incoming');
    Direction_O_instance = new Direction('O', 1, 'Outgoing');
    Direction_U_instance = new Direction('U', 2, 'Unknown');
    Companion_getInstance_8();
  }
  function YesNoUnknown(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.ob_1 = humanReadable;
  }
  function EmailStatus(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.rb_1 = humanReadable;
  }
  function Notified(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.ub_1 = humanReadable;
  }
  function Direction(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.xb_1 = humanReadable;
  }
  function YesNoUnknown_Y_getInstance() {
    YesNoUnknown_initEntries();
    return YesNoUnknown_Y_instance;
  }
  function YesNoUnknown_N_getInstance() {
    YesNoUnknown_initEntries();
    return YesNoUnknown_N_instance;
  }
  function YesNoUnknown_U_getInstance() {
    YesNoUnknown_initEntries();
    return YesNoUnknown_U_instance;
  }
  function EmailStatus_FO_getInstance() {
    EmailStatus_initEntries();
    return EmailStatus_FO_instance;
  }
  function EmailStatus_IP_getInstance() {
    EmailStatus_initEntries();
    return EmailStatus_IP_instance;
  }
  function EmailStatus_QU_getInstance() {
    EmailStatus_initEntries();
    return EmailStatus_QU_instance;
  }
  function EmailStatus_DE_getInstance() {
    EmailStatus_initEntries();
    return EmailStatus_DE_instance;
  }
  function EmailStatus_NF_getInstance() {
    EmailStatus_initEntries();
    return EmailStatus_NF_instance;
  }
  function EmailStatus_ER_getInstance() {
    EmailStatus_initEntries();
    return EmailStatus_ER_instance;
  }
  function Notified_NO_getInstance() {
    Notified_initEntries();
    return Notified_NO_instance;
  }
  function Notified_ER_getInstance() {
    Notified_initEntries();
    return Notified_ER_instance;
  }
  function Notified_MISSING_getInstance() {
    Notified_initEntries();
    return Notified_MISSING_instance;
  }
  function Direction_I_getInstance() {
    Direction_initEntries();
    return Direction_I_instance;
  }
  function Direction_O_getInstance() {
    Direction_initEntries();
    return Direction_O_instance;
  }
  function Direction_U_getInstance() {
    Direction_initEntries();
    return Direction_U_instance;
  }
  function RemediationIncident$SenderPolicyType$Companion$_anonymous__mpta5b() {
    var tmp = values_9();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = ['Quarantine Sender', 'Quarantine Domain', 'Block Sender', 'Block Domain', 'No Sender Policy'];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp_0 = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [null, null, null, null, null];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    return createAnnotatedEnumSerializer('com.barracuda.fir.reporting.domain.RemediationIncident.SenderPolicyType', tmp, tmp_0, tmp$ret$5, null);
  }
  var SenderPolicyType_QS_instance;
  var SenderPolicyType_QD_instance;
  var SenderPolicyType_BS_instance;
  var SenderPolicyType_BD_instance;
  var SenderPolicyType_MISSING_instance;
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.yb_1 = lazy(tmp_0, RemediationIncident$SenderPolicyType$Companion$_anonymous__mpta5b);
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    SenderPolicyType_initEntries();
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function values_9() {
    return [SenderPolicyType_QS_getInstance(), SenderPolicyType_QD_getInstance(), SenderPolicyType_BS_getInstance(), SenderPolicyType_BD_getInstance(), SenderPolicyType_MISSING_getInstance()];
  }
  var SenderPolicyType_entriesInitialized;
  function SenderPolicyType_initEntries() {
    if (SenderPolicyType_entriesInitialized)
      return Unit_getInstance();
    SenderPolicyType_entriesInitialized = true;
    SenderPolicyType_QS_instance = new SenderPolicyType('QS', 0, 'Quarantine Sender');
    SenderPolicyType_QD_instance = new SenderPolicyType('QD', 1, 'Quarantine Domain');
    SenderPolicyType_BS_instance = new SenderPolicyType('BS', 2, 'Block Sender');
    SenderPolicyType_BD_instance = new SenderPolicyType('BD', 3, 'Block Domain');
    SenderPolicyType_MISSING_instance = new SenderPolicyType('MISSING', 4, 'No Sender Policy');
    Companion_getInstance_9();
  }
  function SenderPolicyType(name, ordinal, humanReadable) {
    Enum.call(this, name, ordinal);
    this.bc_1 = humanReadable;
  }
  function SenderPolicyType_QS_getInstance() {
    SenderPolicyType_initEntries();
    return SenderPolicyType_QS_instance;
  }
  function SenderPolicyType_QD_getInstance() {
    SenderPolicyType_initEntries();
    return SenderPolicyType_QD_instance;
  }
  function SenderPolicyType_BS_getInstance() {
    SenderPolicyType_initEntries();
    return SenderPolicyType_BS_instance;
  }
  function SenderPolicyType_BD_getInstance() {
    SenderPolicyType_initEntries();
    return SenderPolicyType_BD_instance;
  }
  function SenderPolicyType_MISSING_getInstance() {
    SenderPolicyType_initEntries();
    return SenderPolicyType_MISSING_instance;
  }
  function Field(name, type, possibleValues) {
    possibleValues = possibleValues === VOID ? null : possibleValues;
    this.name = name;
    this.type = type;
    this.possibleValues = possibleValues;
  }
  protoOf(Field).cc = function () {
    return this.name;
  };
  protoOf(Field).dc = function () {
    return this.type;
  };
  protoOf(Field).ec = function () {
    return this.possibleValues;
  };
  function FieldType() {
    FieldType_instance = this;
    this.BOOLEAN = 'BOOLEAN';
    this.DATE = 'DATE';
    this.NUMBER = 'NUMBER';
    this.TEXT = 'TEXT';
    this.KEYWORD = 'KEYWORD';
    this.ENUM = 'ENUM';
  }
  protoOf(FieldType).fc = function () {
    return this.BOOLEAN;
  };
  protoOf(FieldType).gc = function () {
    return this.DATE;
  };
  protoOf(FieldType).hc = function () {
    return this.NUMBER;
  };
  protoOf(FieldType).ic = function () {
    return this.TEXT;
  };
  protoOf(FieldType).jc = function () {
    return this.KEYWORD;
  };
  protoOf(FieldType).kc = function () {
    return this.ENUM;
  };
  var FieldType_instance;
  function FieldType_getInstance() {
    if (FieldType_instance == null)
      new FieldType();
    return FieldType_instance;
  }
  function Fields() {
  }
  function AutomatedWorkflowsEventFields() {
    AutomatedWorkflowsEventFields_instance = this;
    var tmp = this;
    var tmp_0 = eventCreatedOn$factory().callableName;
    FieldType_getInstance();
    tmp.EVENT_CREATED_ON = new Field(tmp_0, 'DATE');
    var tmp_1 = this;
    var tmp_2 = eventResult$factory().callableName;
    FieldType_getInstance();
    tmp_1.EVENT_RESULT = new Field(tmp_2, 'TEXT');
    var tmp_3 = this;
    var tmp_4 = run$factory().callableName + '.' + createdOn$factory().callableName;
    FieldType_getInstance();
    tmp_3.RUN_CREATED_ON = new Field(tmp_4, 'DATE');
    var tmp_5 = this;
    var tmp_6 = run$factory_0().callableName + '.' + anyActions$factory().callableName;
    FieldType_getInstance();
    tmp_5.RUN_ANY_ACTIONS = new Field(tmp_6, 'BOOLEAN');
    var tmp_7 = this;
    var tmp_8 = run$factory_1().callableName + '.' + workflow$factory().callableName + '.' + uuid$factory().callableName;
    FieldType_getInstance();
    tmp_7.WORKFLOW_UUID = new Field(tmp_8, 'KEYWORD');
    var tmp_9 = this;
    var tmp_10 = run$factory_2().callableName + '.' + workflow$factory_0().callableName + '.' + name$factory().callableName;
    FieldType_getInstance();
    tmp_9.WORKFLOW_NAME = new Field(tmp_10, 'TEXT');
    var tmp_11 = this;
    var tmp_12 = run$factory_3().callableName + '.' + workflow$factory_1().callableName + '.' + enabled$factory().callableName;
    FieldType_getInstance();
    tmp_11.WORKFLOW_ENABLED = new Field(tmp_12, 'BOOLEAN');
    var tmp_13 = this;
    var tmp_14 = run$factory_4().callableName + '.' + workflow$factory_2().callableName + '.' + createdOn$factory_0().callableName;
    FieldType_getInstance();
    tmp_13.WORKFLOW_CREATED_ON = new Field(tmp_14, 'DATE');
    var tmp_15 = this;
    var tmp_16 = run$factory_5().callableName + '.' + workflow$factory_3().callableName + '.' + editor$factory().callableName;
    FieldType_getInstance();
    tmp_15.WORKFLOW_EDITOR = new Field(tmp_16, 'TEXT');
    var tmp_17 = this;
    var tmp_18 = run$factory_6().callableName + '.' + workflow$factory_4().callableName + '.' + description$factory().callableName;
    FieldType_getInstance();
    tmp_17.WORKFLOW_DESCRIPTION = new Field(tmp_18, 'TEXT');
    var tmp_19 = this;
    var tmp_20 = node$factory().callableName + '.' + type$factory().callableName;
    FieldType_getInstance();
    tmp_19.NODE_TYPE = new Field(tmp_20, 'ENUM', this.names(values()));
    var tmp_21 = this;
    var tmp_22 = node$factory_0().callableName + '.' + eventType$factory().callableName;
    FieldType_getInstance();
    tmp_21.NODE_EVENT_TYPE = new Field(tmp_22, 'ENUM', this.names(values_0()));
  }
  protoOf(AutomatedWorkflowsEventFields).lc = function () {
    return this.EVENT_CREATED_ON;
  };
  protoOf(AutomatedWorkflowsEventFields).mc = function () {
    return this.EVENT_RESULT;
  };
  protoOf(AutomatedWorkflowsEventFields).nc = function () {
    return this.RUN_CREATED_ON;
  };
  protoOf(AutomatedWorkflowsEventFields).oc = function () {
    return this.RUN_ANY_ACTIONS;
  };
  protoOf(AutomatedWorkflowsEventFields).pc = function () {
    return this.WORKFLOW_UUID;
  };
  protoOf(AutomatedWorkflowsEventFields).qc = function () {
    return this.WORKFLOW_NAME;
  };
  protoOf(AutomatedWorkflowsEventFields).rc = function () {
    return this.WORKFLOW_ENABLED;
  };
  protoOf(AutomatedWorkflowsEventFields).sc = function () {
    return this.WORKFLOW_CREATED_ON;
  };
  protoOf(AutomatedWorkflowsEventFields).tc = function () {
    return this.WORKFLOW_EDITOR;
  };
  protoOf(AutomatedWorkflowsEventFields).uc = function () {
    return this.WORKFLOW_DESCRIPTION;
  };
  protoOf(AutomatedWorkflowsEventFields).vc = function () {
    return this.NODE_TYPE;
  };
  protoOf(AutomatedWorkflowsEventFields).wc = function () {
    return this.NODE_EVENT_TYPE;
  };
  var AutomatedWorkflowsEventFields_instance;
  function AutomatedWorkflowsEventFields_getInstance() {
    if (AutomatedWorkflowsEventFields_instance == null)
      new AutomatedWorkflowsEventFields();
    return AutomatedWorkflowsEventFields_instance;
  }
  function InsightsUserSubmissionFields() {
    InsightsUserSubmissionFields_instance = this;
    var tmp = this;
    var tmp_0 = senderDomain$factory().callableName;
    FieldType_getInstance();
    tmp.SENDER_DOMAIN = new Field(tmp_0, 'TEXT');
    var tmp_1 = this;
    var tmp_2 = msMessageId$factory().callableName;
    FieldType_getInstance();
    tmp_1.MS_MESSAGE_ID = new Field(tmp_2, 'KEYWORD');
    var tmp_3 = this;
    var tmp_4 = reportedBy$factory().callableName;
    FieldType_getInstance();
    tmp_3.REPORTED_BY = new Field(tmp_4, 'TEXT');
    var tmp_5 = this;
    var tmp_6 = deliveredDate$factory().callableName;
    FieldType_getInstance();
    tmp_5.DELIVERED_DATE = new Field(tmp_6, 'DATE');
    var tmp_7 = this;
    var tmp_8 = reportedDate$factory().callableName;
    FieldType_getInstance();
    tmp_7.REPORTED_DATE = new Field(tmp_8, 'DATE');
    var tmp_9 = this;
    var tmp_10 = state$factory().callableName;
    FieldType_getInstance();
    tmp_9.STATE = new Field(tmp_10, 'ENUM', this.names(values_1()));
    var tmp_11 = this;
    var tmp_12 = matchedEmailCount$factory().callableName;
    FieldType_getInstance();
    tmp_11.MATCHED_EMAIL_COUNT = new Field(tmp_12, 'NUMBER');
    var tmp_13 = this;
    var tmp_14 = isPhishline$factory().callableName;
    FieldType_getInstance();
    tmp_13.IS_PHISHLINE = new Field(tmp_14, 'BOOLEAN');
    var tmp_15 = this;
    var tmp_16 = searchCriteria$factory().callableName + '.' + subjectQuery$factory().callableName;
    FieldType_getInstance();
    tmp_15.SEARCH_CRITERIA_SUBJECT_QUERY = new Field(tmp_16, 'TEXT');
    var tmp_17 = this;
    var tmp_18 = searchCriteria$factory_0().callableName + '.' + senderEmail$factory().callableName;
    FieldType_getInstance();
    tmp_17.SEARCH_CRITERIA_SENDER_EMAIL = new Field(tmp_18, 'TEXT');
  }
  protoOf(InsightsUserSubmissionFields).xc = function () {
    return this.SENDER_DOMAIN;
  };
  protoOf(InsightsUserSubmissionFields).yc = function () {
    return this.MS_MESSAGE_ID;
  };
  protoOf(InsightsUserSubmissionFields).zc = function () {
    return this.REPORTED_BY;
  };
  protoOf(InsightsUserSubmissionFields).ad = function () {
    return this.DELIVERED_DATE;
  };
  protoOf(InsightsUserSubmissionFields).bd = function () {
    return this.REPORTED_DATE;
  };
  protoOf(InsightsUserSubmissionFields).cd = function () {
    return this.STATE;
  };
  protoOf(InsightsUserSubmissionFields).dd = function () {
    return this.MATCHED_EMAIL_COUNT;
  };
  protoOf(InsightsUserSubmissionFields).ed = function () {
    return this.IS_PHISHLINE;
  };
  protoOf(InsightsUserSubmissionFields).fd = function () {
    return this.SEARCH_CRITERIA_SUBJECT_QUERY;
  };
  protoOf(InsightsUserSubmissionFields).gd = function () {
    return this.SEARCH_CRITERIA_SENDER_EMAIL;
  };
  var InsightsUserSubmissionFields_instance;
  function InsightsUserSubmissionFields_getInstance() {
    if (InsightsUserSubmissionFields_instance == null)
      new InsightsUserSubmissionFields();
    return InsightsUserSubmissionFields_instance;
  }
  function RemediationEmailFields() {
    RemediationEmailFields_instance = this;
    var tmp = this;
    var tmp_0 = senderDomain$factory_0().callableName;
    FieldType_getInstance();
    tmp.SENDER_DOMAIN = new Field(tmp_0, 'TEXT');
    var tmp_1 = this;
    var tmp_2 = attachmentCount$factory().callableName;
    FieldType_getInstance();
    tmp_1.ATTACHMENT_COUNT = new Field(tmp_2, 'NUMBER');
    var tmp_3 = this;
    var tmp_4 = clickedOnLinks$factory().callableName;
    FieldType_getInstance();
    tmp_3.CLICKED_ON_LINKS = new Field(tmp_4, 'ENUM', this.names(values_5()));
    var tmp_5 = this;
    var tmp_6 = totalClickedLinks$factory().callableName;
    FieldType_getInstance();
    tmp_5.TOTAL_CLICKED_LINKS = new Field(tmp_6, 'NUMBER');
    var tmp_7 = this;
    var tmp_8 = recipientEmail$factory().callableName;
    FieldType_getInstance();
    tmp_7.RECIPIENT_EMAIL = new Field(tmp_8, 'TEXT');
    var tmp_9 = this;
    var tmp_10 = recipientName$factory().callableName;
    FieldType_getInstance();
    tmp_9.RECIPIENT_NAME = new Field(tmp_10, 'TEXT');
    var tmp_11 = this;
    var tmp_12 = internetMessageId$factory().callableName;
    FieldType_getInstance();
    tmp_11.INTERNET_MESSAGE_ID = new Field(tmp_12, 'KEYWORD');
    var tmp_13 = this;
    var tmp_14 = status$factory().callableName;
    FieldType_getInstance();
    tmp_13.STATUS = new Field(tmp_14, 'ENUM', this.names(values_6()));
    var tmp_15 = this;
    var tmp_16 = isRead$factory().callableName;
    FieldType_getInstance();
    tmp_15.IS_READ = new Field(tmp_16, 'ENUM', this.names(values_5()));
    var tmp_17 = this;
    var tmp_18 = emailId$factory().callableName;
    FieldType_getInstance();
    tmp_17.EMAIL_ID = new Field(tmp_18, 'KEYWORD');
    var tmp_19 = this;
    var tmp_20 = senderEmail$factory_0().callableName;
    FieldType_getInstance();
    tmp_19.SENDER_EMAIL = new Field(tmp_20, 'TEXT');
    var tmp_21 = this;
    var tmp_22 = dateSent$factory().callableName;
    FieldType_getInstance();
    tmp_21.DATE_SENT = new Field(tmp_22, 'DATE');
    var tmp_23 = this;
    var tmp_24 = subject$factory().callableName;
    FieldType_getInstance();
    tmp_23.SUBJECT = new Field(tmp_24, 'TEXT');
    var tmp_25 = this;
    var tmp_26 = notified$factory().callableName;
    FieldType_getInstance();
    tmp_25.NOTIFIED = new Field(tmp_26, 'ENUM', this.names(values_7()));
    var tmp_27 = this;
    var tmp_28 = clickedLinks$factory().callableName;
    FieldType_getInstance();
    tmp_27.CLICKED_LINKS = new Field(tmp_28, 'TEXT');
    var tmp_29 = this;
    var tmp_30 = attachments$factory().callableName;
    FieldType_getInstance();
    tmp_29.ATTACHMENTS = new Field(tmp_30, 'TEXT');
    var tmp_31 = this;
    var tmp_32 = isContinuousRemediation$factory().callableName;
    FieldType_getInstance();
    tmp_31.IS_CONTINUOUS_REMEDIATION = new Field(tmp_32, 'BOOLEAN');
    var tmp_33 = this;
    var tmp_34 = forwarded$factory().callableName;
    FieldType_getInstance();
    tmp_33.FORWARDED = new Field(tmp_34, 'ENUM', this.names(values_5()));
    var tmp_35 = this;
    var tmp_36 = replied$factory().callableName;
    FieldType_getInstance();
    tmp_35.REPLIED = new Field(tmp_36, 'ENUM', this.names(values_5()));
    var tmp_37 = this;
    var tmp_38 = direction$factory().callableName;
    FieldType_getInstance();
    tmp_37.DIRECTION = new Field(tmp_38, 'ENUM', this.names(values_8()));
    var tmp_39 = this;
    var tmp_40 = incident$factory().callableName + '.' + uuid$factory_0().callableName;
    FieldType_getInstance();
    tmp_39.INCIDENT_UUID = new Field(tmp_40, 'KEYWORD');
    var tmp_41 = this;
    var tmp_42 = incident$factory_0().callableName + '.' + createdOn$factory_1().callableName;
    FieldType_getInstance();
    tmp_41.INCIDENT_CREATED_ON = new Field(tmp_42, 'DATE');
    var tmp_43 = this;
    var tmp_44 = incident$factory_1().callableName + '.' + subjectQuery$factory_0().callableName;
    FieldType_getInstance();
    tmp_43.INCIDENT_SUBJECT_QUERY = new Field(tmp_44, 'TEXT');
    var tmp_45 = this;
    var tmp_46 = incident$factory_2().callableName + '.' + senderDisplayName$factory().callableName;
    FieldType_getInstance();
    tmp_45.INCIDENT_SENDER_DISPLAY_NAME = new Field(tmp_46, 'TEXT');
    var tmp_47 = this;
    var tmp_48 = incident$factory_3().callableName + '.' + senderEmail$factory_1().callableName;
    FieldType_getInstance();
    tmp_47.INCIDENT_SENDER_EMAIL = new Field(tmp_48, 'TEXT');
    var tmp_49 = this;
    var tmp_50 = incident$factory_4().callableName + '.' + createdBy$factory().callableName;
    FieldType_getInstance();
    tmp_49.INCIDENT_CREATED_BY = new Field(tmp_50, 'TEXT');
    var tmp_51 = this;
    var tmp_52 = incident$factory_5().callableName + '.' + attachmentQuery$factory().callableName;
    FieldType_getInstance();
    tmp_51.INCIDENT_ATTACHMENT_QUERY = new Field(tmp_52, 'TEXT');
    var tmp_53 = this;
    var tmp_54 = incident$factory_6().callableName + '.' + createdByName$factory().callableName;
    FieldType_getInstance();
    tmp_53.INCIDENT_CREATED_BY_NAME = new Field(tmp_54, 'TEXT');
    var tmp_55 = this;
    var tmp_56 = incident$factory_7().callableName + '.' + bodyTextQuery$factory().callableName;
    FieldType_getInstance();
    tmp_55.INCIDENT_BODY_TEXT_QUERY = new Field(tmp_56, 'TEXT');
    var tmp_57 = this;
    var tmp_58 = incident$factory_8().callableName + '.' + bodyLinksQuery$factory().callableName;
    FieldType_getInstance();
    tmp_57.INCIDENT_BODY_LINKS_QUERY = new Field(tmp_58, 'TEXT');
  }
  protoOf(RemediationEmailFields).xc = function () {
    return this.SENDER_DOMAIN;
  };
  protoOf(RemediationEmailFields).hd = function () {
    return this.ATTACHMENT_COUNT;
  };
  protoOf(RemediationEmailFields).id = function () {
    return this.CLICKED_ON_LINKS;
  };
  protoOf(RemediationEmailFields).jd = function () {
    return this.TOTAL_CLICKED_LINKS;
  };
  protoOf(RemediationEmailFields).kd = function () {
    return this.RECIPIENT_EMAIL;
  };
  protoOf(RemediationEmailFields).ld = function () {
    return this.RECIPIENT_NAME;
  };
  protoOf(RemediationEmailFields).md = function () {
    return this.INTERNET_MESSAGE_ID;
  };
  protoOf(RemediationEmailFields).nd = function () {
    return this.STATUS;
  };
  protoOf(RemediationEmailFields).od = function () {
    return this.IS_READ;
  };
  protoOf(RemediationEmailFields).pd = function () {
    return this.EMAIL_ID;
  };
  protoOf(RemediationEmailFields).qd = function () {
    return this.SENDER_EMAIL;
  };
  protoOf(RemediationEmailFields).rd = function () {
    return this.DATE_SENT;
  };
  protoOf(RemediationEmailFields).sd = function () {
    return this.SUBJECT;
  };
  protoOf(RemediationEmailFields).td = function () {
    return this.NOTIFIED;
  };
  protoOf(RemediationEmailFields).ud = function () {
    return this.CLICKED_LINKS;
  };
  protoOf(RemediationEmailFields).vd = function () {
    return this.ATTACHMENTS;
  };
  protoOf(RemediationEmailFields).wd = function () {
    return this.IS_CONTINUOUS_REMEDIATION;
  };
  protoOf(RemediationEmailFields).xd = function () {
    return this.FORWARDED;
  };
  protoOf(RemediationEmailFields).yd = function () {
    return this.REPLIED;
  };
  protoOf(RemediationEmailFields).zd = function () {
    return this.DIRECTION;
  };
  protoOf(RemediationEmailFields).ae = function () {
    return this.INCIDENT_UUID;
  };
  protoOf(RemediationEmailFields).be = function () {
    return this.INCIDENT_CREATED_ON;
  };
  protoOf(RemediationEmailFields).ce = function () {
    return this.INCIDENT_SUBJECT_QUERY;
  };
  protoOf(RemediationEmailFields).de = function () {
    return this.INCIDENT_SENDER_DISPLAY_NAME;
  };
  protoOf(RemediationEmailFields).ee = function () {
    return this.INCIDENT_SENDER_EMAIL;
  };
  protoOf(RemediationEmailFields).fe = function () {
    return this.INCIDENT_CREATED_BY;
  };
  protoOf(RemediationEmailFields).ge = function () {
    return this.INCIDENT_ATTACHMENT_QUERY;
  };
  protoOf(RemediationEmailFields).he = function () {
    return this.INCIDENT_CREATED_BY_NAME;
  };
  protoOf(RemediationEmailFields).ie = function () {
    return this.INCIDENT_BODY_TEXT_QUERY;
  };
  protoOf(RemediationEmailFields).je = function () {
    return this.INCIDENT_BODY_LINKS_QUERY;
  };
  var RemediationEmailFields_instance;
  function RemediationEmailFields_getInstance() {
    if (RemediationEmailFields_instance == null)
      new RemediationEmailFields();
    return RemediationEmailFields_instance;
  }
  function RemediationIncidentFields() {
    RemediationIncidentFields_instance = this;
    var tmp = this;
    var tmp_0 = maliciousDomainCount$factory().callableName;
    FieldType_getInstance();
    tmp.MALICIOUS_DOMAIN_COUNT = new Field(tmp_0, 'NUMBER');
    var tmp_1 = this;
    var tmp_2 = raQuarantine$factory().callableName;
    FieldType_getInstance();
    tmp_1.RA_QUARANTINE = new Field(tmp_2, 'BOOLEAN');
    var tmp_3 = this;
    var tmp_4 = raDelete$factory().callableName;
    FieldType_getInstance();
    tmp_3.RA_DELETE = new Field(tmp_4, 'BOOLEAN');
    var tmp_5 = this;
    var tmp_6 = raNotify$factory().callableName;
    FieldType_getInstance();
    tmp_5.RA_NOTIFY = new Field(tmp_6, 'BOOLEAN');
    var tmp_7 = this;
    var tmp_8 = raAddBcsPolicy$factory().callableName;
    FieldType_getInstance();
    tmp_7.RA_ADD_BCS_POLICY = new Field(tmp_8, 'BOOLEAN');
    var tmp_9 = this;
    var tmp_10 = raSendSummary$factory().callableName;
    FieldType_getInstance();
    tmp_9.RA_SEND_SUMMARY = new Field(tmp_10, 'BOOLEAN');
    var tmp_11 = this;
    var tmp_12 = senderPoliciesCount$factory().callableName;
    FieldType_getInstance();
    tmp_11.SENDER_POLICIES_COUNT = new Field(tmp_12, 'NUMBER');
    var tmp_13 = this;
    var tmp_14 = senderPolicyType$factory().callableName;
    FieldType_getInstance();
    tmp_13.SENDER_POLICY_TYPE = new Field(tmp_14, 'ENUM', this.names(values_9()));
    var tmp_15 = this;
    var tmp_16 = createdOn$factory_2().callableName;
    FieldType_getInstance();
    tmp_15.CREATED_ON = new Field(tmp_16, 'DATE');
    var tmp_17 = this;
    var tmp_18 = subjectQuery$factory_1().callableName;
    FieldType_getInstance();
    tmp_17.SUBJECT_QUERY = new Field(tmp_18, 'TEXT');
    var tmp_19 = this;
    var tmp_20 = senderDisplayName$factory_0().callableName;
    FieldType_getInstance();
    tmp_19.SENDER_DISPLAY_NAME = new Field(tmp_20, 'TEXT');
    var tmp_21 = this;
    var tmp_22 = senderEmail$factory_2().callableName;
    FieldType_getInstance();
    tmp_21.SENDER_EMAIL = new Field(tmp_22, 'TEXT');
    var tmp_23 = this;
    var tmp_24 = createdBy$factory_0().callableName;
    FieldType_getInstance();
    tmp_23.CREATED_BY = new Field(tmp_24, 'TEXT');
    var tmp_25 = this;
    var tmp_26 = senderPolicies$factory().callableName;
    FieldType_getInstance();
    tmp_25.SENDER_POLICIES = new Field(tmp_26, 'TEXT');
    var tmp_27 = this;
    var tmp_28 = attachmentQuery$factory_0().callableName;
    FieldType_getInstance();
    tmp_27.ATTACHMENT_QUERY = new Field(tmp_28, 'TEXT');
    var tmp_29 = this;
    var tmp_30 = maliciousDomains$factory().callableName;
    FieldType_getInstance();
    tmp_29.MALICIOUS_DOMAINS = new Field(tmp_30, 'TEXT');
    var tmp_31 = this;
    var tmp_32 = crEverEnabled$factory().callableName;
    FieldType_getInstance();
    tmp_31.CR_EVER_ENABLED = new Field(tmp_32, 'BOOLEAN');
    var tmp_33 = this;
    var tmp_34 = createdByName$factory_0().callableName;
    FieldType_getInstance();
    tmp_33.CREATED_BY_NAME = new Field(tmp_34, 'TEXT');
    var tmp_35 = this;
    var tmp_36 = bodyTextQuery$factory_0().callableName;
    FieldType_getInstance();
    tmp_35.BODY_TEXT_QUERY = new Field(tmp_36, 'TEXT');
    var tmp_37 = this;
    var tmp_38 = bodyLinksQuery$factory_0().callableName;
    FieldType_getInstance();
    tmp_37.BODY_LINKS_QUERY = new Field(tmp_38, 'TEXT');
  }
  protoOf(RemediationIncidentFields).ke = function () {
    return this.MALICIOUS_DOMAIN_COUNT;
  };
  protoOf(RemediationIncidentFields).le = function () {
    return this.RA_QUARANTINE;
  };
  protoOf(RemediationIncidentFields).me = function () {
    return this.RA_DELETE;
  };
  protoOf(RemediationIncidentFields).ne = function () {
    return this.RA_NOTIFY;
  };
  protoOf(RemediationIncidentFields).oe = function () {
    return this.RA_ADD_BCS_POLICY;
  };
  protoOf(RemediationIncidentFields).pe = function () {
    return this.RA_SEND_SUMMARY;
  };
  protoOf(RemediationIncidentFields).qe = function () {
    return this.SENDER_POLICIES_COUNT;
  };
  protoOf(RemediationIncidentFields).re = function () {
    return this.SENDER_POLICY_TYPE;
  };
  protoOf(RemediationIncidentFields).se = function () {
    return this.CREATED_ON;
  };
  protoOf(RemediationIncidentFields).te = function () {
    return this.SUBJECT_QUERY;
  };
  protoOf(RemediationIncidentFields).ue = function () {
    return this.SENDER_DISPLAY_NAME;
  };
  protoOf(RemediationIncidentFields).qd = function () {
    return this.SENDER_EMAIL;
  };
  protoOf(RemediationIncidentFields).ve = function () {
    return this.CREATED_BY;
  };
  protoOf(RemediationIncidentFields).we = function () {
    return this.SENDER_POLICIES;
  };
  protoOf(RemediationIncidentFields).xe = function () {
    return this.ATTACHMENT_QUERY;
  };
  protoOf(RemediationIncidentFields).ye = function () {
    return this.MALICIOUS_DOMAINS;
  };
  protoOf(RemediationIncidentFields).ze = function () {
    return this.CR_EVER_ENABLED;
  };
  protoOf(RemediationIncidentFields).af = function () {
    return this.CREATED_BY_NAME;
  };
  protoOf(RemediationIncidentFields).bf = function () {
    return this.BODY_TEXT_QUERY;
  };
  protoOf(RemediationIncidentFields).cf = function () {
    return this.BODY_LINKS_QUERY;
  };
  var RemediationIncidentFields_instance;
  function RemediationIncidentFields_getInstance() {
    if (RemediationIncidentFields_instance == null)
      new RemediationIncidentFields();
    return RemediationIncidentFields_instance;
  }
  function PipelineSpThreatFields() {
    PipelineSpThreatFields_instance = this;
    var tmp = this;
    var tmp_0 = createdOn$factory_3().callableName;
    FieldType_getInstance();
    tmp.CREATED_ON = new Field(tmp_0, 'DATE');
    var tmp_1 = this;
    var tmp_2 = isRead$factory_0().callableName;
    FieldType_getInstance();
    tmp_1.IS_READ = new Field(tmp_2, 'BOOLEAN');
    var tmp_3 = this;
    var tmp_4 = senderIpAddress$factory().callableName;
    FieldType_getInstance();
    tmp_3.SENDER_IP_ADDRESS = new Field(tmp_4, 'TEXT');
    var tmp_5 = this;
    var tmp_6 = senderDomainRegistrationDate$factory().callableName;
    FieldType_getInstance();
    tmp_5.SENDER_DOMAIN_REGISTRATION_DATE = new Field(tmp_6, 'DATE');
    var tmp_7 = this;
    var tmp_8 = senderIpLocation$factory().callableName;
    FieldType_getInstance();
    tmp_7.SENDER_IP_LOCATION = new Field(tmp_8, 'KEYWORD');
    var tmp_9 = this;
    var tmp_10 = senderIpReputation$factory().callableName;
    FieldType_getInstance();
    tmp_9.SENDER_IP_REPUTATION = new Field(tmp_10, 'NUMBER');
    var tmp_11 = this;
    var tmp_12 = subject$factory_0().callableName;
    FieldType_getInstance();
    tmp_11.SUBJECT = new Field(tmp_12, 'TEXT');
    var tmp_13 = this;
    var tmp_14 = dateReceived$factory().callableName;
    FieldType_getInstance();
    tmp_13.DATE_RECEIVED = new Field(tmp_14, 'DATE');
    var tmp_15 = this;
    var tmp_16 = dateSent$factory_0().callableName;
    FieldType_getInstance();
    tmp_15.DATE_SEND = new Field(tmp_16, 'DATE');
    var tmp_17 = this;
    var tmp_18 = hasAttachments$factory().callableName;
    FieldType_getInstance();
    tmp_17.HAS_ATTACHMENTS = new Field(tmp_18, 'BOOLEAN');
    var tmp_19 = this;
    var tmp_20 = emailId$factory_0().callableName;
    FieldType_getInstance();
    tmp_19.EMAIL_ID = new Field(tmp_20, 'KEYWORD');
    var tmp_21 = this;
    var tmp_22 = internetMessageId$factory_0().callableName;
    FieldType_getInstance();
    tmp_21.INTERNET_MESSAGE_ID = new Field(tmp_22, 'KEYWORD');
    var tmp_23 = this;
    var tmp_24 = parentFolderName$factory().callableName;
    FieldType_getInstance();
    tmp_23.PARENT_FOLDER_NAME = new Field(tmp_24, 'TEXT');
    var tmp_25 = this;
    var tmp_26 = threatDetectsCount$factory().callableName;
    FieldType_getInstance();
    tmp_25.THREAT_DETECTS_COUNT = new Field(tmp_26, 'NUMBER');
    var tmp_27 = this;
    var tmp_28 = taxonomy$factory().callableName;
    FieldType_getInstance();
    tmp_27.TAXONOMY = new Field(tmp_28, 'ENUM', this.names(values_2()));
    var tmp_29 = this;
    var tmp_30 = severity$factory().callableName;
    FieldType_getInstance();
    tmp_29.SEVERITY = new Field(tmp_30, 'NUMBER');
    var tmp_31 = this;
    var tmp_32 = servicePhishingKeywords$factory().callableName;
    FieldType_getInstance();
    tmp_31.SERVICE_PHISHING_KEYWORDS = new Field(tmp_32, 'TEXT');
    var tmp_33 = this;
    var tmp_34 = servicePhishingDomains$factory().callableName;
    FieldType_getInstance();
    tmp_33.SERVICE_PHISHING_DOMAINS = new Field(tmp_34, 'TEXT');
    var tmp_35 = this;
    var tmp_36 = confidence$factory().callableName;
    FieldType_getInstance();
    tmp_35.CONFIDENCE = new Field(tmp_36, 'ENUM', this.names(values_3()));
    var tmp_37 = this;
    var tmp_38 = isWhitelisted$factory().callableName;
    FieldType_getInstance();
    tmp_37.IS_WHITELISTED = new Field(tmp_38, 'BOOLEAN');
    var tmp_39 = this;
    var tmp_40 = identity$factory().callableName + '.' + email$factory().callableName;
    FieldType_getInstance();
    tmp_39.IDENTITY_EMAIL = new Field(tmp_40, 'TEXT');
    var tmp_41 = this;
    var tmp_42 = identity$factory_0().callableName + '.' + displayName$factory().callableName;
    FieldType_getInstance();
    tmp_41.IDENTITY_DISPLAY_NAME = new Field(tmp_42, 'TEXT');
    var tmp_43 = this;
    var tmp_44 = identity$factory_1().callableName + '.' + jobTitle$factory().callableName;
    FieldType_getInstance();
    tmp_43.IDENTITY_JOB_TITLE = new Field(tmp_44, 'TEXT');
    var tmp_45 = this;
    var tmp_46 = identity$factory_2().callableName + '.' + department$factory().callableName;
    FieldType_getInstance();
    tmp_45.IDENTITY_DEPARTMENT = new Field(tmp_46, 'TEXT');
    var tmp_47 = this;
    var tmp_48 = correspondentSenderEmail$factory().callableName;
    FieldType_getInstance();
    tmp_47.CORRESPONDENT_SENDER_EMAIL = new Field(tmp_48, 'TEXT');
    var tmp_49 = this;
    var tmp_50 = correspondentSenderDomain$factory().callableName;
    FieldType_getInstance();
    tmp_49.CORRESPONDENT_SENDER_DOMAIN = new Field(tmp_50, 'TEXT');
    var tmp_51 = this;
    var tmp_52 = correspondentSenderDisplayName$factory().callableName;
    FieldType_getInstance();
    tmp_51.CORRESPONDENT_SENDER_DISPLAY_NAME = new Field(tmp_52, 'TEXT');
    var tmp_53 = this;
    var tmp_54 = status$factory_0().callableName;
    FieldType_getInstance();
    tmp_53.STATUS = new Field(tmp_54, 'ENUM', this.names(values_4()));
  }
  protoOf(PipelineSpThreatFields).se = function () {
    return this.CREATED_ON;
  };
  protoOf(PipelineSpThreatFields).od = function () {
    return this.IS_READ;
  };
  protoOf(PipelineSpThreatFields).df = function () {
    return this.SENDER_IP_ADDRESS;
  };
  protoOf(PipelineSpThreatFields).ef = function () {
    return this.SENDER_DOMAIN_REGISTRATION_DATE;
  };
  protoOf(PipelineSpThreatFields).ff = function () {
    return this.SENDER_IP_LOCATION;
  };
  protoOf(PipelineSpThreatFields).gf = function () {
    return this.SENDER_IP_REPUTATION;
  };
  protoOf(PipelineSpThreatFields).sd = function () {
    return this.SUBJECT;
  };
  protoOf(PipelineSpThreatFields).hf = function () {
    return this.DATE_RECEIVED;
  };
  protoOf(PipelineSpThreatFields).if = function () {
    return this.DATE_SEND;
  };
  protoOf(PipelineSpThreatFields).jf = function () {
    return this.HAS_ATTACHMENTS;
  };
  protoOf(PipelineSpThreatFields).pd = function () {
    return this.EMAIL_ID;
  };
  protoOf(PipelineSpThreatFields).md = function () {
    return this.INTERNET_MESSAGE_ID;
  };
  protoOf(PipelineSpThreatFields).kf = function () {
    return this.PARENT_FOLDER_NAME;
  };
  protoOf(PipelineSpThreatFields).lf = function () {
    return this.THREAT_DETECTS_COUNT;
  };
  protoOf(PipelineSpThreatFields).mf = function () {
    return this.TAXONOMY;
  };
  protoOf(PipelineSpThreatFields).nf = function () {
    return this.SEVERITY;
  };
  protoOf(PipelineSpThreatFields).of = function () {
    return this.SERVICE_PHISHING_KEYWORDS;
  };
  protoOf(PipelineSpThreatFields).pf = function () {
    return this.SERVICE_PHISHING_DOMAINS;
  };
  protoOf(PipelineSpThreatFields).qf = function () {
    return this.CONFIDENCE;
  };
  protoOf(PipelineSpThreatFields).rf = function () {
    return this.IS_WHITELISTED;
  };
  protoOf(PipelineSpThreatFields).sf = function () {
    return this.IDENTITY_EMAIL;
  };
  protoOf(PipelineSpThreatFields).tf = function () {
    return this.IDENTITY_DISPLAY_NAME;
  };
  protoOf(PipelineSpThreatFields).uf = function () {
    return this.IDENTITY_JOB_TITLE;
  };
  protoOf(PipelineSpThreatFields).vf = function () {
    return this.IDENTITY_DEPARTMENT;
  };
  protoOf(PipelineSpThreatFields).wf = function () {
    return this.CORRESPONDENT_SENDER_EMAIL;
  };
  protoOf(PipelineSpThreatFields).xf = function () {
    return this.CORRESPONDENT_SENDER_DOMAIN;
  };
  protoOf(PipelineSpThreatFields).yf = function () {
    return this.CORRESPONDENT_SENDER_DISPLAY_NAME;
  };
  protoOf(PipelineSpThreatFields).nd = function () {
    return this.STATUS;
  };
  var PipelineSpThreatFields_instance;
  function PipelineSpThreatFields_getInstance() {
    if (PipelineSpThreatFields_instance == null)
      new PipelineSpThreatFields();
    return PipelineSpThreatFields_instance;
  }
  function eventCreatedOn$factory() {
    return getPropertyCallableRef('eventCreatedOn', 1, KProperty1, function (receiver) {
      return receiver.zf_1;
    }, null);
  }
  function eventResult$factory() {
    return getPropertyCallableRef('eventResult', 1, KProperty1, function (receiver) {
      return receiver.bg_1;
    }, null);
  }
  function run$factory() {
    return getPropertyCallableRef('run', 1, KProperty1, function (receiver) {
      return receiver.cg_1;
    }, null);
  }
  function createdOn$factory() {
    return getPropertyCallableRef('createdOn', 1, KProperty1, function (receiver) {
      return receiver.eg_1;
    }, null);
  }
  function run$factory_0() {
    return getPropertyCallableRef('run', 1, KProperty1, function (receiver) {
      return receiver.cg_1;
    }, null);
  }
  function anyActions$factory() {
    return getPropertyCallableRef('anyActions', 1, KProperty1, function (receiver) {
      return receiver.dg_1;
    }, null);
  }
  function run$factory_1() {
    return getPropertyCallableRef('run', 1, KProperty1, function (receiver) {
      return receiver.cg_1;
    }, null);
  }
  function workflow$factory() {
    return getPropertyCallableRef('workflow', 1, KProperty1, function (receiver) {
      return receiver.fg_1;
    }, null);
  }
  function uuid$factory() {
    return getPropertyCallableRef('uuid', 1, KProperty1, function (receiver) {
      return receiver.lg_1;
    }, null);
  }
  function run$factory_2() {
    return getPropertyCallableRef('run', 1, KProperty1, function (receiver) {
      return receiver.cg_1;
    }, null);
  }
  function workflow$factory_0() {
    return getPropertyCallableRef('workflow', 1, KProperty1, function (receiver) {
      return receiver.fg_1;
    }, null);
  }
  function name$factory() {
    return getPropertyCallableRef('name', 1, KProperty1, function (receiver) {
      return receiver.gg_1;
    }, null);
  }
  function run$factory_3() {
    return getPropertyCallableRef('run', 1, KProperty1, function (receiver) {
      return receiver.cg_1;
    }, null);
  }
  function workflow$factory_1() {
    return getPropertyCallableRef('workflow', 1, KProperty1, function (receiver) {
      return receiver.fg_1;
    }, null);
  }
  function enabled$factory() {
    return getPropertyCallableRef('enabled', 1, KProperty1, function (receiver) {
      return receiver.kg_1;
    }, null);
  }
  function run$factory_4() {
    return getPropertyCallableRef('run', 1, KProperty1, function (receiver) {
      return receiver.cg_1;
    }, null);
  }
  function workflow$factory_2() {
    return getPropertyCallableRef('workflow', 1, KProperty1, function (receiver) {
      return receiver.fg_1;
    }, null);
  }
  function createdOn$factory_0() {
    return getPropertyCallableRef('createdOn', 1, KProperty1, function (receiver) {
      return receiver.ig_1;
    }, null);
  }
  function run$factory_5() {
    return getPropertyCallableRef('run', 1, KProperty1, function (receiver) {
      return receiver.cg_1;
    }, null);
  }
  function workflow$factory_3() {
    return getPropertyCallableRef('workflow', 1, KProperty1, function (receiver) {
      return receiver.fg_1;
    }, null);
  }
  function editor$factory() {
    return getPropertyCallableRef('editor', 1, KProperty1, function (receiver) {
      return receiver.jg_1;
    }, null);
  }
  function run$factory_6() {
    return getPropertyCallableRef('run', 1, KProperty1, function (receiver) {
      return receiver.cg_1;
    }, null);
  }
  function workflow$factory_4() {
    return getPropertyCallableRef('workflow', 1, KProperty1, function (receiver) {
      return receiver.fg_1;
    }, null);
  }
  function description$factory() {
    return getPropertyCallableRef('description', 1, KProperty1, function (receiver) {
      return receiver.hg_1;
    }, null);
  }
  function node$factory() {
    return getPropertyCallableRef('node', 1, KProperty1, function (receiver) {
      return receiver.ag_1;
    }, null);
  }
  function type$factory() {
    return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
      return receiver.mg_1;
    }, null);
  }
  function node$factory_0() {
    return getPropertyCallableRef('node', 1, KProperty1, function (receiver) {
      return receiver.ag_1;
    }, null);
  }
  function eventType$factory() {
    return getPropertyCallableRef('eventType', 1, KProperty1, function (receiver) {
      return receiver.ng_1;
    }, null);
  }
  function senderDomain$factory() {
    return getPropertyCallableRef('senderDomain', 1, KProperty1, function (receiver) {
      return receiver.tg_1;
    }, null);
  }
  function msMessageId$factory() {
    return getPropertyCallableRef('msMessageId', 1, KProperty1, function (receiver) {
      return receiver.wg_1;
    }, null);
  }
  function reportedBy$factory() {
    return getPropertyCallableRef('reportedBy', 1, KProperty1, function (receiver) {
      return receiver.pg_1;
    }, null);
  }
  function deliveredDate$factory() {
    return getPropertyCallableRef('deliveredDate', 1, KProperty1, function (receiver) {
      return receiver.vg_1;
    }, null);
  }
  function reportedDate$factory() {
    return getPropertyCallableRef('reportedDate', 1, KProperty1, function (receiver) {
      return receiver.og_1;
    }, null);
  }
  function state$factory() {
    return getPropertyCallableRef('state', 1, KProperty1, function (receiver) {
      return receiver.qg_1;
    }, null);
  }
  function matchedEmailCount$factory() {
    return getPropertyCallableRef('matchedEmailCount', 1, KProperty1, function (receiver) {
      return receiver.rg_1;
    }, null);
  }
  function isPhishline$factory() {
    return getPropertyCallableRef('isPhishline', 1, KProperty1, function (receiver) {
      return receiver.sg_1;
    }, null);
  }
  function searchCriteria$factory() {
    return getPropertyCallableRef('searchCriteria', 1, KProperty1, function (receiver) {
      return receiver.ug_1;
    }, null);
  }
  function subjectQuery$factory() {
    return getPropertyCallableRef('subjectQuery', 1, KProperty1, function (receiver) {
      return receiver.yg_1;
    }, null);
  }
  function searchCriteria$factory_0() {
    return getPropertyCallableRef('searchCriteria', 1, KProperty1, function (receiver) {
      return receiver.ug_1;
    }, null);
  }
  function senderEmail$factory() {
    return getPropertyCallableRef('senderEmail', 1, KProperty1, function (receiver) {
      return receiver.xg_1;
    }, null);
  }
  function senderDomain$factory_0() {
    return getPropertyCallableRef('senderDomain', 1, KProperty1, function (receiver) {
      return receiver.mh_1;
    }, null);
  }
  function attachmentCount$factory() {
    return getPropertyCallableRef('attachmentCount', 1, KProperty1, function (receiver) {
      return receiver.ph_1;
    }, null);
  }
  function clickedOnLinks$factory() {
    return getPropertyCallableRef('clickedOnLinks', 1, KProperty1, function (receiver) {
      return receiver.fh_1;
    }, null);
  }
  function totalClickedLinks$factory() {
    return getPropertyCallableRef('totalClickedLinks', 1, KProperty1, function (receiver) {
      return receiver.gh_1;
    }, null);
  }
  function recipientEmail$factory() {
    return getPropertyCallableRef('recipientEmail', 1, KProperty1, function (receiver) {
      return receiver.dh_1;
    }, null);
  }
  function recipientName$factory() {
    return getPropertyCallableRef('recipientName', 1, KProperty1, function (receiver) {
      return receiver.eh_1;
    }, null);
  }
  function internetMessageId$factory() {
    return getPropertyCallableRef('internetMessageId', 1, KProperty1, function (receiver) {
      return receiver.sh_1;
    }, null);
  }
  function status$factory() {
    return getPropertyCallableRef('status', 1, KProperty1, function (receiver) {
      return receiver.ah_1;
    }, null);
  }
  function isRead$factory() {
    return getPropertyCallableRef('isRead', 1, KProperty1, function (receiver) {
      return receiver.ih_1;
    }, null);
  }
  function emailId$factory() {
    return getPropertyCallableRef('emailId', 1, KProperty1, function (receiver) {
      return receiver.rh_1;
    }, null);
  }
  function senderEmail$factory_0() {
    return getPropertyCallableRef('senderEmail', 1, KProperty1, function (receiver) {
      return receiver.lh_1;
    }, null);
  }
  function dateSent$factory() {
    return getPropertyCallableRef('dateSent', 1, KProperty1, function (receiver) {
      return receiver.zg_1;
    }, null);
  }
  function subject$factory() {
    return getPropertyCallableRef('subject', 1, KProperty1, function (receiver) {
      return receiver.nh_1;
    }, null);
  }
  function notified$factory() {
    return getPropertyCallableRef('notified', 1, KProperty1, function (receiver) {
      return receiver.ch_1;
    }, null);
  }
  function clickedLinks$factory() {
    return getPropertyCallableRef('clickedLinks', 1, KProperty1, function (receiver) {
      return receiver.hh_1;
    }, null);
  }
  function attachments$factory() {
    return getPropertyCallableRef('attachments', 1, KProperty1, function (receiver) {
      return receiver.qh_1;
    }, null);
  }
  function isContinuousRemediation$factory() {
    return getPropertyCallableRef('isContinuousRemediation', 1, KProperty1, function (receiver) {
      return receiver.bh_1;
    }, null);
  }
  function forwarded$factory() {
    return getPropertyCallableRef('forwarded', 1, KProperty1, function (receiver) {
      return receiver.jh_1;
    }, null);
  }
  function replied$factory() {
    return getPropertyCallableRef('replied', 1, KProperty1, function (receiver) {
      return receiver.kh_1;
    }, null);
  }
  function direction$factory() {
    return getPropertyCallableRef('direction', 1, KProperty1, function (receiver) {
      return receiver.oh_1;
    }, null);
  }
  function incident$factory() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function uuid$factory_0() {
    return getPropertyCallableRef('uuid', 1, KProperty1, function (receiver) {
      return receiver.xh_1;
    }, null);
  }
  function incident$factory_0() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function createdOn$factory_1() {
    return getPropertyCallableRef('createdOn', 1, KProperty1, function (receiver) {
      return receiver.uh_1;
    }, null);
  }
  function incident$factory_1() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function subjectQuery$factory_0() {
    return getPropertyCallableRef('subjectQuery', 1, KProperty1, function (receiver) {
      return receiver.ai_1;
    }, null);
  }
  function incident$factory_2() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function senderDisplayName$factory() {
    return getPropertyCallableRef('senderDisplayName', 1, KProperty1, function (receiver) {
      return receiver.zh_1;
    }, null);
  }
  function incident$factory_3() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function senderEmail$factory_1() {
    return getPropertyCallableRef('senderEmail', 1, KProperty1, function (receiver) {
      return receiver.yh_1;
    }, null);
  }
  function incident$factory_4() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function createdBy$factory() {
    return getPropertyCallableRef('createdBy', 1, KProperty1, function (receiver) {
      return receiver.vh_1;
    }, null);
  }
  function incident$factory_5() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function attachmentQuery$factory() {
    return getPropertyCallableRef('attachmentQuery', 1, KProperty1, function (receiver) {
      return receiver.di_1;
    }, null);
  }
  function incident$factory_6() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function createdByName$factory() {
    return getPropertyCallableRef('createdByName', 1, KProperty1, function (receiver) {
      return receiver.wh_1;
    }, null);
  }
  function incident$factory_7() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function bodyTextQuery$factory() {
    return getPropertyCallableRef('bodyTextQuery', 1, KProperty1, function (receiver) {
      return receiver.bi_1;
    }, null);
  }
  function incident$factory_8() {
    return getPropertyCallableRef('incident', 1, KProperty1, function (receiver) {
      return receiver.th_1;
    }, null);
  }
  function bodyLinksQuery$factory() {
    return getPropertyCallableRef('bodyLinksQuery', 1, KProperty1, function (receiver) {
      return receiver.ci_1;
    }, null);
  }
  function maliciousDomainCount$factory() {
    return getPropertyCallableRef('maliciousDomainCount', 1, KProperty1, function (receiver) {
      return receiver.wi_1;
    }, null);
  }
  function raQuarantine$factory() {
    return getPropertyCallableRef('raQuarantine', 1, KProperty1, function (receiver) {
      return receiver.pi_1;
    }, null);
  }
  function raDelete$factory() {
    return getPropertyCallableRef('raDelete', 1, KProperty1, function (receiver) {
      return receiver.oi_1;
    }, null);
  }
  function raNotify$factory() {
    return getPropertyCallableRef('raNotify', 1, KProperty1, function (receiver) {
      return receiver.ni_1;
    }, null);
  }
  function raAddBcsPolicy$factory() {
    return getPropertyCallableRef('raAddBcsPolicy', 1, KProperty1, function (receiver) {
      return receiver.vi_1;
    }, null);
  }
  function raSendSummary$factory() {
    return getPropertyCallableRef('raSendSummary', 1, KProperty1, function (receiver) {
      return receiver.ri_1;
    }, null);
  }
  function senderPoliciesCount$factory() {
    return getPropertyCallableRef('senderPoliciesCount', 1, KProperty1, function (receiver) {
      return receiver.ti_1;
    }, null);
  }
  function senderPolicyType$factory() {
    return getPropertyCallableRef('senderPolicyType', 1, KProperty1, function (receiver) {
      return receiver.si_1;
    }, null);
  }
  function createdOn$factory_2() {
    return getPropertyCallableRef('createdOn', 1, KProperty1, function (receiver) {
      return receiver.ei_1;
    }, null);
  }
  function subjectQuery$factory_1() {
    return getPropertyCallableRef('subjectQuery', 1, KProperty1, function (receiver) {
      return receiver.ji_1;
    }, null);
  }
  function senderDisplayName$factory_0() {
    return getPropertyCallableRef('senderDisplayName', 1, KProperty1, function (receiver) {
      return receiver.ii_1;
    }, null);
  }
  function senderEmail$factory_2() {
    return getPropertyCallableRef('senderEmail', 1, KProperty1, function (receiver) {
      return receiver.hi_1;
    }, null);
  }
  function createdBy$factory_0() {
    return getPropertyCallableRef('createdBy', 1, KProperty1, function (receiver) {
      return receiver.fi_1;
    }, null);
  }
  function senderPolicies$factory() {
    return getPropertyCallableRef('senderPolicies', 1, KProperty1, function (receiver) {
      return receiver.ui_1;
    }, null);
  }
  function attachmentQuery$factory_0() {
    return getPropertyCallableRef('attachmentQuery', 1, KProperty1, function (receiver) {
      return receiver.ki_1;
    }, null);
  }
  function maliciousDomains$factory() {
    return getPropertyCallableRef('maliciousDomains', 1, KProperty1, function (receiver) {
      return receiver.xi_1;
    }, null);
  }
  function crEverEnabled$factory() {
    return getPropertyCallableRef('crEverEnabled', 1, KProperty1, function (receiver) {
      return receiver.qi_1;
    }, null);
  }
  function createdByName$factory_0() {
    return getPropertyCallableRef('createdByName', 1, KProperty1, function (receiver) {
      return receiver.gi_1;
    }, null);
  }
  function bodyTextQuery$factory_0() {
    return getPropertyCallableRef('bodyTextQuery', 1, KProperty1, function (receiver) {
      return receiver.li_1;
    }, null);
  }
  function bodyLinksQuery$factory_0() {
    return getPropertyCallableRef('bodyLinksQuery', 1, KProperty1, function (receiver) {
      return receiver.mi_1;
    }, null);
  }
  function createdOn$factory_3() {
    return getPropertyCallableRef('createdOn', 1, KProperty1, function (receiver) {
      return receiver.yi_1;
    }, null);
  }
  function isRead$factory_0() {
    return getPropertyCallableRef('isRead', 1, KProperty1, function (receiver) {
      return receiver.aj_1;
    }, null);
  }
  function senderIpAddress$factory() {
    return getPropertyCallableRef('senderIpAddress', 1, KProperty1, function (receiver) {
      return receiver.ej_1;
    }, null);
  }
  function senderDomainRegistrationDate$factory() {
    return getPropertyCallableRef('senderDomainRegistrationDate', 1, KProperty1, function (receiver) {
      return receiver.fj_1;
    }, null);
  }
  function senderIpLocation$factory() {
    return getPropertyCallableRef('senderIpLocation', 1, KProperty1, function (receiver) {
      return receiver.gj_1;
    }, null);
  }
  function senderIpReputation$factory() {
    return getPropertyCallableRef('senderIpReputation', 1, KProperty1, function (receiver) {
      return receiver.hj_1;
    }, null);
  }
  function subject$factory_0() {
    return getPropertyCallableRef('subject', 1, KProperty1, function (receiver) {
      return receiver.ij_1;
    }, null);
  }
  function dateReceived$factory() {
    return getPropertyCallableRef('dateReceived', 1, KProperty1, function (receiver) {
      return receiver.kj_1;
    }, null);
  }
  function dateSent$factory_0() {
    return getPropertyCallableRef('dateSent', 1, KProperty1, function (receiver) {
      return receiver.lj_1;
    }, null);
  }
  function hasAttachments$factory() {
    return getPropertyCallableRef('hasAttachments', 1, KProperty1, function (receiver) {
      return receiver.mj_1;
    }, null);
  }
  function emailId$factory_0() {
    return getPropertyCallableRef('emailId', 1, KProperty1, function (receiver) {
      return receiver.nj_1;
    }, null);
  }
  function internetMessageId$factory_0() {
    return getPropertyCallableRef('internetMessageId', 1, KProperty1, function (receiver) {
      return receiver.oj_1;
    }, null);
  }
  function parentFolderName$factory() {
    return getPropertyCallableRef('parentFolderName', 1, KProperty1, function (receiver) {
      return receiver.pj_1;
    }, null);
  }
  function threatDetectsCount$factory() {
    return getPropertyCallableRef('threatDetectsCount', 1, KProperty1, function (receiver) {
      return receiver.qj_1;
    }, null);
  }
  function taxonomy$factory() {
    return getPropertyCallableRef('taxonomy', 1, KProperty1, function (receiver) {
      return receiver.rj_1;
    }, null);
  }
  function severity$factory() {
    return getPropertyCallableRef('severity', 1, KProperty1, function (receiver) {
      return receiver.vj_1;
    }, null);
  }
  function servicePhishingKeywords$factory() {
    return getPropertyCallableRef('servicePhishingKeywords', 1, KProperty1, function (receiver) {
      return receiver.sj_1;
    }, null);
  }
  function servicePhishingDomains$factory() {
    return getPropertyCallableRef('servicePhishingDomains', 1, KProperty1, function (receiver) {
      return receiver.tj_1;
    }, null);
  }
  function confidence$factory() {
    return getPropertyCallableRef('confidence', 1, KProperty1, function (receiver) {
      return receiver.uj_1;
    }, null);
  }
  function isWhitelisted$factory() {
    return getPropertyCallableRef('isWhitelisted', 1, KProperty1, function (receiver) {
      return receiver.wj_1;
    }, null);
  }
  function identity$factory() {
    return getPropertyCallableRef('identity', 1, KProperty1, function (receiver) {
      return receiver.zi_1;
    }, null);
  }
  function email$factory() {
    return getPropertyCallableRef('email', 1, KProperty1, function (receiver) {
      return receiver.xj_1;
    }, null);
  }
  function identity$factory_0() {
    return getPropertyCallableRef('identity', 1, KProperty1, function (receiver) {
      return receiver.zi_1;
    }, null);
  }
  function displayName$factory() {
    return getPropertyCallableRef('displayName', 1, KProperty1, function (receiver) {
      return receiver.yj_1;
    }, null);
  }
  function identity$factory_1() {
    return getPropertyCallableRef('identity', 1, KProperty1, function (receiver) {
      return receiver.zi_1;
    }, null);
  }
  function jobTitle$factory() {
    return getPropertyCallableRef('jobTitle', 1, KProperty1, function (receiver) {
      return receiver.zj_1;
    }, null);
  }
  function identity$factory_2() {
    return getPropertyCallableRef('identity', 1, KProperty1, function (receiver) {
      return receiver.zi_1;
    }, null);
  }
  function department$factory() {
    return getPropertyCallableRef('department', 1, KProperty1, function (receiver) {
      return receiver.ak_1;
    }, null);
  }
  function correspondentSenderEmail$factory() {
    return getPropertyCallableRef('correspondentSenderEmail', 1, KProperty1, function (receiver) {
      return receiver.bj_1;
    }, null);
  }
  function correspondentSenderDomain$factory() {
    return getPropertyCallableRef('correspondentSenderDomain', 1, KProperty1, function (receiver) {
      return receiver.dj_1;
    }, null);
  }
  function correspondentSenderDisplayName$factory() {
    return getPropertyCallableRef('correspondentSenderDisplayName', 1, KProperty1, function (receiver) {
      return receiver.cj_1;
    }, null);
  }
  function status$factory_0() {
    return getPropertyCallableRef('status', 1, KProperty1, function (receiver) {
      return receiver.jj_1;
    }, null);
  }
  function FilterOperation_0() {
    FilterOperation_instance = this;
    this.EQUALS = FilterOperation_EQUALS_getInstance().b7_1;
    this.NOT_EQUALS = FilterOperation_NOT_EQUALS_getInstance().b7_1;
    this.IN = FilterOperation_IN_getInstance().b7_1;
    this.NOT_IN = FilterOperation_NOT_IN_getInstance().b7_1;
    this.CONTAINS = FilterOperation_CONTAINS_getInstance().b7_1;
    this.NOT_CONTAINS = FilterOperation_NOT_CONTAINS_getInstance().b7_1;
    this.LESS = FilterOperation_LESS_getInstance().b7_1;
    this.LESS_EQUAL = FilterOperation_LESS_EQUAL_getInstance().b7_1;
    this.GREATER = FilterOperation_GREATER_getInstance().b7_1;
    this.GREATER_EQUAL = FilterOperation_GREATER_EQUAL_getInstance().b7_1;
    this.BETWEEN = FilterOperation_BETWEEN_getInstance().b7_1;
    this.BLANK = FilterOperation_BLANK_getInstance().b7_1;
    this.NOT_BLANK = FilterOperation_NOT_BLANK_getInstance().b7_1;
    this.DATE_EQUALS = FilterOperation_DATE_EQUALS_getInstance().b7_1;
  }
  protoOf(FilterOperation_0).bk = function () {
    return this.EQUALS;
  };
  protoOf(FilterOperation_0).ck = function () {
    return this.NOT_EQUALS;
  };
  protoOf(FilterOperation_0).dk = function () {
    return this.IN;
  };
  protoOf(FilterOperation_0).ek = function () {
    return this.NOT_IN;
  };
  protoOf(FilterOperation_0).fk = function () {
    return this.CONTAINS;
  };
  protoOf(FilterOperation_0).gk = function () {
    return this.NOT_CONTAINS;
  };
  protoOf(FilterOperation_0).hk = function () {
    return this.LESS;
  };
  protoOf(FilterOperation_0).ik = function () {
    return this.LESS_EQUAL;
  };
  protoOf(FilterOperation_0).jk = function () {
    return this.GREATER;
  };
  protoOf(FilterOperation_0).kk = function () {
    return this.GREATER_EQUAL;
  };
  protoOf(FilterOperation_0).lk = function () {
    return this.BETWEEN;
  };
  protoOf(FilterOperation_0).mk = function () {
    return this.BLANK;
  };
  protoOf(FilterOperation_0).nk = function () {
    return this.NOT_BLANK;
  };
  protoOf(FilterOperation_0).ok = function () {
    return this.DATE_EQUALS;
  };
  var FilterOperation_instance;
  function FilterOperation_getInstance() {
    if (FilterOperation_instance == null)
      new FilterOperation_0();
    return FilterOperation_instance;
  }
  //region block: post-declaration
  protoOf(AutomatedWorkflowsEventFields).names = names;
  protoOf(InsightsUserSubmissionFields).names = names;
  protoOf(RemediationEmailFields).names = names;
  protoOf(RemediationIncidentFields).names = names;
  protoOf(PipelineSpThreatFields).names = names;
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    _.Field = Field;
    defineProp(_, 'FieldType', FieldType_getInstance);
    defineProp(_, 'AutomatedWorkflowsEventFields', AutomatedWorkflowsEventFields_getInstance);
    defineProp(_, 'InsightsUserSubmissionFields', InsightsUserSubmissionFields_getInstance);
    defineProp(_, 'RemediationEmailFields', RemediationEmailFields_getInstance);
    defineProp(_, 'RemediationIncidentFields', RemediationIncidentFields_getInstance);
    defineProp(_, 'PipelineSpThreatFields', PipelineSpThreatFields_getInstance);
    defineProp(_, 'FilterOperation', FilterOperation_getInstance);
  }
  $jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=reporting-shared.js.map
